import List from 'containers/Users/List';
import Edit from 'containers/Users/Edit';
import Create from 'containers/Users/Create';
import Show from 'containers/Users/Show';

export default { List, Edit, Create, Show };
